export const validationMixin = {
  data: () => ({
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid",
      v => (v && v.length <= 100) || "E-mail must be less than 100 characters"
    ],
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length >= 8) || "Password must be at least 8 characters",
      v => (v && v.length <= 20) || "Password must be less than 20 characters"
    ],
    firstNameRules: [
      v => !!v || "First name is required",
      v => (v && v.length <= 50) || "First name must be less than 50 characters"
    ],
    lastNameRules: [
      v => !!v || "Last name is required.",
      v => (v && v.length <= 50) || "Last name must be less than 50 characters"
    ],
    phoneNumberRules: [
      v => !!v || "Phone number is required",
      v =>
        (v && v.length <= 20) || "Phone number must be less than 20 characters"
    ]
  })
};
